var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHuman = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Human",
    transform: "translate(0 -149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "user-solid",
    d: "M9.177,10.488A5.244,5.244,0,1,0,3.933,5.244,5.244,5.244,0,0,0,9.177,10.488ZM7.3,12.454a7.3,7.3,0,0,0-7.3,7.3,1.217,1.217,0,0,0,1.217,1.217h15.92a1.217,1.217,0,0,0,1.217-1.217,7.3,7.3,0,0,0-7.3-7.3Z",
    transform: "translate(15.47 162.703)",
    fill: "#8b8b8b"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHuman);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Human.a275875f4bfa7d57fb7cd2180de748f4.svg";